import React from 'react';
import Icon from './Icon';

type AlertVariant = 'info' | 'warn' | 'danger' | 'success';
const ICONS: Record<AlertVariant, string> = { info: 'info', warn: 'warn', danger: 'x', success: 'check' };

interface AlertProps {
  variant?: AlertVariant;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export default function Alert({ variant = 'info', children, style }: AlertProps) {
  return (
    <div className={`t-alert ${variant}`} style={style}>
      <Icon name={ICONS[variant]} size={14} color={`var(--${variant})`} />
      <span>{children}</span>
    </div>
  );
}
